import React, { useState } from "react";

import StatusCalendlyComp from "components/embeds/statusCalendly";
import PaperPlaneIcon from "images/icons/paper-plane.inline.svg";
import ThumsUpIcon from "images/icons/thumbs-up.inline.svg";

export const StatusComp = ({
  children,
  expText,
  statusText,
  status,
  align = "left",
  txtColor = "text-green-dark",
  iconColor = "text-green-dark fill-green-dark",
  formType,
  iconPosition = "",
  mainTitleExtra = "",
  extraContainerClass = "sm:w-3/4 mx-auto gap-2 flex flex-col",
  calendlyHeading,
  calendlyDesc,
  isGold = false,
  calendlyLayout = "inline",
  calendlyActive = false,
  calendlyPrefill = {}
}) => {
  const [calendlyOverlay, setCalendlyOverlay] = useState(false);
  return (
    <div
      className={`w-full ${
        align === "center" ? "text-center" : "text-left"
      } ${extraContainerClass}`}
    >
      {calendlyOverlay === false && (
        <>
          <div
            className={`flex gap-x-8 ${
              iconPosition === "top" ? "items-start flex-col" : "items-center"
            } ${align === "center" ? "justify-center" : "justify-start"}`}
          >
            {status === "processing" ? (
              <PaperPlaneIcon className={`h-10 w-10 shrink-0 ${iconColor}`} />
            ) : (
              <ThumsUpIcon className={`h-10 w-10 shrink-0 ${iconColor}`} />
            )}
            <h1
              className={`font-normal shrink-0 ${txtColor} ${mainTitleExtra}`}
              dangerouslySetInnerHTML={{ __html: expText }}
            />
          </div>

          <div
            className={`text-xl font-normal ${txtColor}`}
            dangerouslySetInnerHTML={{ __html: statusText }}
          />

          {children}
        </>
      )}

      <StatusCalendlyComp
        calendlyHeading={calendlyHeading}
        calendlyDesc={calendlyDesc}
        isGold={isGold}
        calendlyLayout={calendlyLayout}
        calendlyActive={calendlyActive}
        calendlyPrefill={calendlyPrefill}
        setCalendlyOverlay={setCalendlyOverlay}
        status={status}
        iconColor={iconColor}
        txtColor={txtColor}
      />
    </div>
  );
};
